exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-contact[data-v-23c4725e]{font-size:13px}.vc-contact a[data-v-23c4725e]{text-decoration:underline}.vc-contact a[data-v-23c4725e]:hover{text-decoration:none}", ""]);

// exports
